<template>
  <div class="container">
    <div class="bj">
      <div class="top">
        <div class="logo"></div>
        <div class="titleText">智慧环保监管平台</div>
      </div>
      <div class="register">
        <div class="registerBox">
          <el-form
            id="formEle"
            action=""
            method="POST"
            ref="form"
            :model="form"
            style="text-align: center;"
          >
            <div class="userLoginAa">用户登录</div>
            <div class="errorMsg" >{{errorMsg}}</div>
            <el-form-item
              class="username"
              prop="username"
              :rules="propRules.s1"
            >
              <el-input
                class="input"
                clearable
                name="username"
                v-model="form.username"
                placeholder="请输入用户名"
              >
                <div
                  style="position:relative"
                  slot="prefix"
                >
                  <i class="iconfont">&#xe65a;</i>
                  <span class="line"></span>
                </div>
              </el-input>
            </el-form-item>

            <el-form-item
              class="password"
              prop="password"
              :rules="propRules.s2"
            >
              <el-input
                class="input"
                clearable
                :show-password="false"
                name="password"
                v-model="form.password"
                placeholder="请输入密码"
                type="password"
              >
                <div
                  style="position:relative"
                  slot="prefix"
                >
                  <i class="iconfont">&#xe65a;</i>
                  <span class="line"></span>
                </div>

              </el-input>
            </el-form-item>

            <input
              type="hidden"
              name="deviceType"
              value="PC"
            >

            <el-form-item style="text-align: left;">
              <el-checkbox
                name="rememberMe"
                v-model="rememberMe"
                style="font-size: 12px;color: #999;vertical-align:middle;"
                :label="true"
              >
                <span style="vertical-align:middle;">记住用户名和密码</span>
              </el-checkbox>
            </el-form-item>
            <el-form-item style="margin-bottom: 0px;">
              <el-button
                class="inputBtn"
                type="primary"
                @click="clickLogin"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footer-vue></footer-vue>
  </div>
</template>

<script>
import footerVue from "@/view/footer/footer.vue";
import { mapMutations } from "vuex";
import { login } from "@/http/api.js";
export default {
  name: "login",
  data() {
    let validPassword=(rule,value,callback)=>{
      let reg= /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
      if(!reg.test(value)){callback(new Error('密码必须是由8-20位字母+数字组合'))
      }else{
          callback()
      }
    };
    return {
      form: {
        // username: "bl001",
        // password: "123456",
        username: "",
        password: "",
        deviceType: "PC"
      },
      userjwt: "",
      rememberMe: false,
      propRules: {
        s1: [
          {
            required: true,
            message: "请输入用户名"
          }
        ],
        s2: [
          {
            required: true,
            message: "请输入密码"
          },
          { required: true, validator: validPassword, trigger: "blur" }
        ]
      },
      permission: [],
      errorMsg: null
    };
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    
    loginfn(formName) {
      formName = 'form'
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 博罗
          // login(this.form).then(res => {
          //   if (res.code != 0) {
          //     that.$message.error(res.msg);
          //     return;
          //   }
          //   that.userToken = res.data.token;
          //   that.permission = res.data.permissionList;
          //   // 将用户token保存到vuex中
          //   that.changeLogin({ Authorization: that.userToken });
          //   // 行政区域
          //   that.$store.commit("setAdministrativeName", res.data.user.mapKey);
          //   sessionStorage.setItem("administrativeName", res.data.user.mapKey);
          //   //权限管理
          //   that.$store.commit("setPermission", that.permission);
          //   sessionStorage.setItem("permission", res.data.permissionList);
          //   sessionStorage.setItem("id", res.data.user.id);
          //   if (that.rememberMe) {
          //     localStorage.setItem("password", that.form.password);
          //     localStorage.setItem("username", that.form.username);
          //   } else {
          //     localStorage.removeItem("password");
          //     localStorage.removeItem("username");
          //   }
          //    // 用户类型存储
          //    that.$store.commit("setUserType", res.data.user.userType);
          //   sessionStorage.setItem("userType", res.data.user.userType);
          //   if (res.data.user.userType == "admin") {
          //     // this.$router.push("/dataCenterManage");
          //     this.$router.push("/index/workbench");
          //   } else  {
          //     this.skip(res.data.permissionList);
          //   }
          // });
          // 大亚湾
          let keyPublic = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCO1erFyK0r4iprlf1YlPTQA5jtmmBECGvq37VccljBMA1a+1axeSJ461JdgxUsoF3SDSzm16QgIAHPUjwnMwFSjvogN0y4MCt40cK8tHMTVU/wMWUZNZwGWmGxi/1hmGD544VEHEVnFNmt5nUCr2cJisin52On6jFUtXYYnXEpswIDAQAB'
          let formData=JSON.stringify(this.form)
          const jse = new this.$jsEncrypt()
          jse.setPublicKey(keyPublic)//配置公钥
          formData = jse.encrypt(formData)//加密账号
          login(formData).then(res => {
            if (res.code != 0) {
              this.errorMsg = res.msg
              return;
            }
            that.userjwt = res.data.jwt;
            that.permission = res.data.permissionList;
            // 将用户jwt保存到vuex中
            that.changeLogin({ Authorization: that.userjwt });
            // 行政区域
            that.$store.commit("setAdministrativeName", res.data.mapKey);
            sessionStorage.setItem("administrativeName", res.data.mapKey);
            //权限管理
            that.$store.commit("setPermission", that.permission);
            sessionStorage.setItem("permission", res.data.permissionList);
            sessionStorage.setItem("id", res.data.userId);
            if (that.rememberMe) {
              localStorage.setItem("password", that.form.password);
              localStorage.setItem("username", that.form.username);
            } else {
              localStorage.removeItem("password");
              localStorage.removeItem("username");
            }
             // 用户类型存储
             that.$store.commit("setUserType", res.data.userType);
            sessionStorage.setItem("userType", res.data.userType);
            if (res.data.userType == "admin") {
              // this.$router.push("/dataCenterManage");
              this.$router.push("/index/workbench");
            } else  {
              this.skip(res.data.permissionList);
            }
          });
        } else {
          return false;
        }
      });
    },
    skip(arr){
      if(arr.indexOf('p009') != '-1'){
        this.$router.push("/index/workbench");
      }else if(arr.indexOf('p046') != '-1'){
        this.$router.push("/index/workbench");
      }else if(arr.indexOf('p013') != '-1'){
        this.$router.push("/index/company_warn");
      }else if(arr.indexOf('p006') != '-1'){
        this.$router.push("/index/bloggers");
      }else if(arr.indexOf('p047') != '-1'){
        this.$router.push("/index/leninstatistics");
      }else if(arr.indexOf('p021') != '-1'){
        this.$router.push("/index/discharge");
      }else if(arr.indexOf('p022') != '-1'){
        this.$router.push("/index/concentration");
      }else if(arr.indexOf('p015') != '-1'){
        this.$router.push("/index/management");
      }else if(arr.indexOf('p024') != '-1'){
        this.$router.push("/index/floatingRate");
      }else if(arr.indexOf('p027') != '-1'){
        this.$router.push("/index/basinMsg");
      }else if(arr.indexOf('p033') != '-1'){
        this.$router.push("/index/rightManagement");
      }else{
        this.$router.push("/index/workbench");
      }
      // else if(arr.indexOf('p009') != '-1'){
      //   this.$router.push("/index/personalCenter");
      // }else if(arr.indexOf('p044') != '-1'){
      //   this.$router.push("/index/userResponse");
      // }
    }
  },
  components: { footerVue },
  created() {
    if (localStorage.getItem("password") && localStorage.getItem("username")) {
      this.form.password = localStorage.getItem("password");
      this.form.username = localStorage.getItem("username");
      this.rememberMe = true;
    }
    this.clickLogin = this.debounce(this.loginfn, 3000, true)
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  width: 100vw;
  height: 100vh;

  .bj {
    width: 100vw;
    height: calc(100vh - 60px);
    background-image: url(./../../assets/bj.jpg);
    background-size: 100% 100%;

    .top {
      width: 100%;
      height: 88px;
      padding: 14px 30px;
      display: flex;
      align-items: center;

      .logo {
        float: left;
        width: 60px;
        height: 60px;
        background-image: url(./../../assets/logo.png);
        background-size: 100% 100%;
      }

      .titleText {
        float: left;
        font-size: 32px;
        line-height: 60px;
        color: #fff;
        margin-left: 15px;
      }
    }

    .register {
      position: absolute;
      top: 50%;
      left: 85%;
      width: 400px;
      height: 390px;
      margin-left: -400px;
      margin-top: -195px;
      background-color: #fff;
      padding: 40px;

      .registerBox {
        width: 100%;
        height: 100%;
        .username {
          margin-bottom: 30px;
        }
        .password {
          margin-bottom: 18px;
        }
        .userLoginAa {
          color: #239ced;
          font-size: 24px;
          text-align: left;
          padding-bottom: 34px;
        }
        .errorMsg {
          color: #F56C6C;
          font-size: 14px;
          text-align: left;
          padding-bottom: 4px;
        }
        .iconfont {
          font-size: 30px;
        }
        .input {
          width: 320px;
          height: 44px;
        }
        .inputBtn {
          width: 320px;
          height: 44px;
          font-size: 18px;
          letter-spacing: 20px;
          padding: 0;
        }
        .line {
          position: absolute;
          background-color: #ddd;
          width: 1px; /* no*/
          height: 25px;
          display: inline-block;
          top: 8px;
          right: -2px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue